import { render } from "./EndTestView.vue?vue&type=template&id=5827b9b0&scoped=true"
import script from "./EndTestView.vue?vue&type=script&lang=js"
export * from "./EndTestView.vue?vue&type=script&lang=js"

import "./EndTestView.vue?vue&type=style&index=0&id=5827b9b0&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src821934687/src/cuco-prova-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5827b9b0"]])

export default __exports__